var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "partner-inactive",
    transform: "translate(-2.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "partner-active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-stuff-icon",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5925926,27.7222222 C6.13674848,27.7222222 0.0925925926,21.6780664 0.0925925926,14.2222222 C0.0925925926,6.76637811 6.13674848,0.722222222 13.5925926,0.722222222 C21.0484368,0.722222222 27.0925926,6.76637811 27.0925926,14.2222222 C27.0925926,21.6780664 21.0484368,27.7222222 13.5925926,27.7222222 Z M13.5925926,26.0347223 C20.1164562,26.0347223 25.4050927,20.7460859 25.4050927,14.2222222 C25.4050927,7.69835862 20.1164562,2.40972222 13.5925926,2.40972222 C7.068729,2.40972222 1.78009259,7.69835862 1.78009259,14.2222222 C1.78009259,20.7460859 7.068729,26.0347223 13.5925926,26.0347223 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,19.9233177 C24.3450232,21.4573621 23.4156409,22.8383649 22.2760778,24 L16.5757589,19.8780212 C14.5137482,21.2274878 11.7837934,21.2499955 9.65920957,19.7136798 C7.53462579,18.177364 6.62140653,15.5204272 7.14407184,13.0578388 L13.0385155,17.320192 L15.7893978,13.2630047 L9.89495413,9.0006516 C11.9569649,7.65118503 14.6869196,7.62867732 16.8115035,9.16499305 C18.9360874,10.7013088 19.8493065,13.3582456 19.3266412,15.8208341 L25,19.9233177 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.77777778
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerActive);
export default __webpack_public_path__ + "static/media/partner-active.323ec85ef6d065e0e80c1cd334c5c029.svg";
export { ForwardRef as ReactComponent };